import {
  Alert,
  AlertDescription,
  AlertIcon,
  StyleProps,
} from "@chakra-ui/react";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ApiErrorData,
  filterExcludedNonFieldErrors,
  flattenApiErrorData,
  getApiErrorFromResponse,
  getErrorMessage,
  isFieldPathValidFormInput,
} from "shared/utils/ErrorUtils";

export interface FormErrorAlertProps extends StyleProps {
  error: unknown;
  excludeNonFieldErrors?: string[];
}

export const FormErrorAlert: React.FC<FormErrorAlertProps> = ({
  error,
  excludeNonFieldErrors,
  ...props
}) => {
  const { t } = useTranslation(["common"]);
  const form = useFormContext();

  if (!error) {
    return null;
  }

  const apiError = getApiErrorFromResponse(error);
  if (apiError?.code === "invalid" && apiError.data) {
    const hasNonFieldErrors = flattenApiErrorData(
      filterExcludedNonFieldErrors(
        apiError.data,
        excludeNonFieldErrors,
      ) as ApiErrorData,
    ).some((e) => !isFieldPathValidFormInput(form, e.fieldPath));
    if (!hasNonFieldErrors) {
      // all field errors are displayed inline
      return null;
    }
  }

  return (
    <Alert status="error" {...props}>
      <AlertIcon />
      <AlertDescription>{getErrorMessage(t, error)}</AlertDescription>
    </Alert>
  );
};
